var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficesIconStaffListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 7.5H9.75V6H8.25V7.5ZM8.25 10.5H9.75V9H8.25V10.5ZM9.75 15V12H8.25V15H6V5.25H8.25H9.75H12V15H9.75ZM15 13.5V15H13.5V3.75H12H9.75V1.5H8.25V3.75H6H4.5V15H3V13.5H1.5V15V16.5H4.5H6H12H13.5H16.5V15V13.5H15Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficesIconStaffListing);
export default __webpack_public_path__ + "static/media/offices_icon_staff_listing.a2b0cce938b0b97fcff6e53351b706e7.svg";
export { ForwardRef as ReactComponent };